// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalAnswer-module__numberBill--Nnvyg {
    color: #0054E6;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/widgets/modal-answer/ModalAnswer.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;AACrB","sourcesContent":[".numberBill {\r\n    color: #0054E6;\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numberBill": `ModalAnswer-module__numberBill--Nnvyg`
};
export default ___CSS_LOADER_EXPORT___;
